/* ks-forms.js (KS v31, 23 Oct 2026, audit LEAD-09)
   The quote form on /pages/contact lives in the page content (English and Filipino). Its "Your message" field
   was required even when the buyer had already picked a product, a crop, an area and a country. This makes it
   optional, as on Chemiseed (CS v29): name, email and country stay required. The form's own script still appends
   the enquiry details (country, product, crop, area, buyer type) to the message when it is sent, so the email the
   team receives is never empty.
   If this file fails to load, the form keeps working as before (the message stays required). */
(function () {
  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  ready(function () {
    var el = document.getElementById('kzc-body');
    if (!el || !el.form || el.form.id !== 'contact_form') return;
    el.removeAttribute('required');
    el.setAttribute('aria-required', 'false');
    var label = document.querySelector('label[for="kzc-body"]');
    if (label) {
      label.classList.add('ks-optional');
      var star = label.querySelector('.kzc-req');
      if (star) star.hidden = true;
    }
  });
})();
